import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import TitleBar from './components/common/TitleBar';
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import Error from './pages/Error';
import Spinner from './components/common/Spinner';
import OrganizationalStructure from './components/core/AboutPage/OrganizationalStructure';
import WebAdministrator from './pages/WebAdministrator';
import ForecastDashboard from './pages/ForecastDashboard';
import ModelProducts from './components/core/ForecastDashboardPage/ForecastSidebarMenu/ModelProducts';
import Disclaimer from './pages/Disclaimer';
import ContactUs from './pages/ContactUs';
import ContactHead from './components/common/ContactUs/ContactHead';
import Publications from './pages/Publications';
import Milestones from './pages/Milestones';
import Bimstec from './pages/Bimstec';
import JobDetails from './components/core/AboutPage/CareersPage/AllJobsPage/JobDetails';
import Login from './pages/Login';
import Employees from './pages/Employees';
import RajbhashaPortal from './pages/RajbhashaPortal';
import SignUp from './pages/SignUp';

// Lazy-loaded pages
const Home = React.lazy(() => import('./pages/Home'));
const About = React.lazy(() => import('./pages/About'));
const DirectorDesk = React.lazy(
  () => import('./components/core/AboutPage/DirectorDesk')
);
const Careers = React.lazy(() => import('./pages/Careers'));
const AllJobs = React.lazy(() => import('./pages/AllJobs'));

const Research = React.lazy(() => import('./pages/Research'));
const AllSpecialProducts = React.lazy(
  () => import('./pages/AllSpecialProducts')
);
const ForecastProducts = React.lazy(() => import('./pages/ForecastProducts'));

function App() {
  return (
    <div className="min-h-screen w-screen bg-white">
      <React.Suspense fallback={<Spinner />}>
        <TitleBar />
      </React.Suspense>
      <React.Suspense fallback={<Spinner />}>
        <Navbar />
      </React.Suspense>

      <Routes>
        <Route
          path="/"
          element={
            <React.Suspense fallback={<Spinner />}>
              <Home />
            </React.Suspense>
          }
        />
        <Route
          path="/about-us"
          element={
            <React.Suspense fallback={<Spinner />}>
              <About />
            </React.Suspense>
          }
        />
        <Route
          path="/about/directors-desk"
          element={
            <React.Suspense fallback={<Spinner />}>
              <DirectorDesk />
            </React.Suspense>
          }
        />
        <Route
          path="/about-us/organizationalstructure"
          element={
            <React.Suspense fallback={<Spinner />}>
              <OrganizationalStructure />
            </React.Suspense>
          }
        />
        <Route
          path="/about/careers"
          element={
            <React.Suspense fallback={<Spinner />}>
              <Careers />
            </React.Suspense>
          }
        />
        <Route element={<ForecastDashboard />}>
          <Route path="forecast-dashboard/*" element={<ModelProducts />} />
        </Route>

        <Route
          path="/all-jobs"
          element={
            <React.Suspense fallback={<Spinner />}>
              <AllJobs />
            </React.Suspense>
          }
        />

        <Route path="/job-detail" element={<JobDetails />} />

        <Route
          path="/research"
          element={
            <React.Suspense fallback={<Spinner />}>
              <Research />
            </React.Suspense>
          }
        />
        <Route
          path="/bimstec"
          element={
            <React.Suspense fallback={<Spinner />}>
              <Bimstec />
            </React.Suspense>
          }
        />
        <Route
          path="/publications"
          element={
            <React.Suspense fallback={<Spinner />}>
              <Publications />
            </React.Suspense>
          }
        />
        <Route
          path="/computing/milestones"
          element={
            <React.Suspense fallback={<Spinner />}>
              <Milestones />
            </React.Suspense>
          }
        />
        <Route
          path="/special-products"
          element={
            <React.Suspense fallback={<Spinner />}>
              <AllSpecialProducts />
            </React.Suspense>
          }
        />
        <Route
          path="/forecast-products/:modelType"
          element={
            <React.Suspense fallback={<Spinner />}>
              <ForecastProducts />
            </React.Suspense>
          }
        />
        <Route
          path="/about/employees"
          element={
            <React.Suspense fallback={<Spinner />}>
              <Employees />
            </React.Suspense>
          }
        />

        <Route
          path="/web-administrator"
          element={
            <React.Suspense fallback={<Spinner />}>
              <WebAdministrator />
            </React.Suspense>
          }
        />
        <Route
          path="/disclaimer"
          element={
            <React.Suspense fallback={<Spinner />}>
              <Disclaimer />
            </React.Suspense>
          }
        />
        <Route
          path="/contact-us"
          element={
            <React.Suspense fallback={<Spinner />}>
              <ContactUs />
            </React.Suspense>
          }
        />
        {/* <Route path="/rajbhasha-portal" element={<RajbhashaPortal />} /> */}

        <Route path="/contact-us/head" element={<ContactHead />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </div>
  );
}

export default App;
